module.exports = __webpack_public_path__ + "img/eclipsecross-19.df471913.png";